var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSubjectExpert = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 12,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#subject_expert_svg__a)",
  stroke: "#FEF9C3",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.488 11.548V10.5c.047-.382.387-.639.772-.639h.423c.71 0 1.285-.576 1.285-1.286V7.39c.48.018.73-.02 1.016-.197.287-.177.382-.543.284-.866C10.41 3.49 9.07.643 5.254.643c-2.925 0-4.611 1.5-4.611 4.5 0 2.05.535 2.738 1.182 3.785.356.576.507 1.25.505 1.928l-.001.692"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.476 6.446C3.872 6.9 2.98 6.9 2.74 6.184c-.317-.949-.08-2.187 1.002-2.98 1.064-.814 2.316-.69 3.136-.118.618.432.366 1.288-.238 1.74l-2.164 1.62Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "subject_expert_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h12v12H0z"
})))));
export default SvgSubjectExpert;